import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResourceDirective } from './directives/i18n-key.directive';
import { EnumListPipe } from './pipes/enum-list.pipe';
import { I18nPipe } from './pipes/i18n.pipe';
import { I18nEnumPipe, I18nErrorPipe } from './pipes/resource-enum.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    I18nPipe,
    I18nEnumPipe,
    I18nErrorPipe,
    EnumListPipe,
    ResourceDirective,
  ],
  exports: [
    I18nPipe,
    I18nEnumPipe,
    I18nErrorPipe,
    EnumListPipe,
    ResourceDirective,
  ],
})
export class TunnelSanteI18nModule {}
